import { EMapLayer } from '../../types';
import { EUpwellingDepth } from './types';

/**/
const DEPTH_VALUES = [
  0.5, 1.5, 2.6, 3.8, 5.1, 6.4, 7.9, 9.6, 11.4, 13.5, 15.8, 18.5, 21, 25, 29,
  34, 40, 47, 55, 65, 77, 92, 110, 130, 155, 186, 222, 266, 318, 380, 454, 541,
  644, 763, 902, 1062, 1245, 1452, 1684, 1941, 2225, 2533, 2865, 3220, 3597,
  3992, 4405, 4833, 5274 /*, 5727*/
];

/**/
const ZOOPLANKTON_DEPTH_VALUES = [
  0.5, 2, 3, 4, 5, 6, 8, 10, 11, 13, 16, 18, 22, 25, 29, 34, 40, 47, 56, 66, 78,
  92, 110, 131, 156, 186, 222, 266, 318, 380, 454, 541, 644, 763, 902, 1062,
  2000, 3000, 3500 /*, 4000*/
];

/**/
const defaults = {
  depth: 0.5,
  depthRange: { min: 0.5, max: 5274 /*5727*/ },
  opacity: 1
};

/**
 *
 */
export function getUpwellingRange(depth) {
  if (depth === EUpwellingDepth.DEPTH_0) return [-5, 5];
  return [-1000, 1000];
}

/**
 *
 */
export function getUpwellingMaxRange(depth) {
  if (depth === EUpwellingDepth.DEPTH_0) return [-5, 5];
  return [-1000, 1000];
}

/**/
export const DEFAULT_LAYER_VALUES = {
  [EMapLayer.CHLOROPHYLL]: {
    ...defaults,
    range: [0, 5],
    maxRange: [0, 5]
  },
  [EMapLayer.ICE_COVERAGE]: {
    opacity: 1,
    range: [0, 1],
    maxRange: [0, 1]
  },
  [EMapLayer.PHYTOPLANKTON]: {
    ...defaults,
    range: [0, 20],
    maxRange: [0, 20]
  },
  [EMapLayer.SALINITY]: {
    ...defaults,
    range: [25, 40],
    maxRange: [25, 40]
  },
  [EMapLayer.SEATEMP]: {
    ...defaults,
    range: [-5, 30],
    maxRange: [-5, 30]
  },
  [EMapLayer.SURFACETEMP]: {
    ...defaults,
    range: [-5, 30],
    maxRange: [-5, 30]
  },
  [EMapLayer.UPWELLING]: {
    depth: 0.5,
    opacity: 1,
    range: getUpwellingRange,
    maxRange: getUpwellingMaxRange
  },
  [EMapLayer.ZOOPLANKTON]: {
    depth: 0.5,
    depthRange: { min: 0.5, max: 3500 /*4000*/ },
    opacity: 1,
    range: [0, 40],
    maxRange: [0, 40]
  }
};

/**/
export const DEPTH_AVAILABILITY_LAYERS = [
  EMapLayer.CHLOROPHYLL,
  EMapLayer.PHYTOPLANKTON,
  EMapLayer.SALINITY,
  EMapLayer.SEATEMP,
  EMapLayer.UPWELLING,
  EMapLayer.ZOOPLANKTON
];

/**/
export const LAYER_DEPTHS_MAP = {
  [EMapLayer.CHLOROPHYLL]: DEPTH_VALUES,
  [EMapLayer.ICE_COVERAGE]: [0],
  [EMapLayer.PHYTOPLANKTON]: DEPTH_VALUES,
  [EMapLayer.SALINITY]: DEPTH_VALUES,
  [EMapLayer.SEATEMP]: DEPTH_VALUES,
  [EMapLayer.SURFACETEMP]: DEPTH_VALUES,
  [EMapLayer.UPWELLING]: [0.5, 50, 100],
  [EMapLayer.ZOOPLANKTON]: ZOOPLANKTON_DEPTH_VALUES
};
